<template>
  <div class="live">    
    <main-content right-sidebar="true"></main-content>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'

export default {
  name: 'live',
  
  components: { MainContent }
}
</script>
<style lang="scss">
</style>
